import { UPLOAD_STATUS } from "../previewDocuments/upload/DocumentUpload";

export const init = (payload) => {
  const {
    isSupplement,
    progress,
    request,
    letters,
    attachments,
    supplements,
    finances,
    additionalDocs,
    supplementDocs,
    uploadConstraints,
    statusColor,
  } = payload;

  let supplementDocuments = supplementDocs.map((supplementDoc) => {
    return {
      ...supplementDoc,
      /* color: "grey", */
      uploadError: null,
      uploadProgress: 0,
      uploadStatus: UPLOAD_STATUS.NOT_STARTED,
      file: null,
      href: supplementDoc.href !== null ? supplementDoc.href : null,
      required: false,
    };
  });

  return {
    isSupplement,
    progress,
    request,
    letters: [...letters],
    attachments: [...attachments],
    supplements: [...supplements],
    finances: [...finances],
    additionalDocs: [...additionalDocs],
    supplementDocs: [...supplementDocuments],
    uploadConstraints: { ...uploadConstraints },
    solveWithoutDecision: false,
    statusColor,
  };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "init":
      return init(action.payload);

    case "update-documents":
      /*state.supplementDocs
        .filter((supplementDoc) => supplementDoc.supplementRequired)
        .concat(state.supplementDocs)
        .forEach((doc) => {
          doc.color = statusColor(doc.uploadStatus);
        }); */
      state.isSupplement = true;
      return { ...state /* ...state.isSupplement  */ };

    case "submit":
      action.payload.color = "green";
      action.payload.supplementRequired = false;

      return { ...state, ...action.payload };

    case "remove":
      const index = state.supplementDocs.findIndex((doc) => {
        return JSON.stringify(doc) === JSON.stringify(action.payload);
      });
      state.supplementDocs.splice(index, 1);

      return { state };

    case "setVerificationCode":
      const i = state.supplementDocs.findIndex((doc) => {
        return JSON.stringify(doc) === JSON.stringify(action.payload.doc);
      });

      state.supplementDocs[i].href = action.payload.href;

      return { ...state };

    case "sendBack":
      action.payload.color = "red";
      action.payload.supplementRequired = true;

      return { ...state, ...action.payload };

    case "noSupplement":
      state.isSupplement = false;
      return { ...state };

    case "supplement":
      state.isSupplement = true;
      return { ...state };

    case "sendError":
      action.payload[1].error = action.payload[0];
      return { ...state, ...action.payload.doc };

    case "setSolveWithoutDecision":
      state.solveWithoutDecision = true;
      return { ...state };

    default:
      return { state };
  }
};
